<template>
  <section class="about_us" id="about">
    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <div class="about_left_txt">
            <div class="title">
              <h3>Бидний
                <b>тухай</b>
              </h3>
              <div class="underline"></div>
              <div class="btn-group">
                <a class="btn" id="btnIntrodcution" @click="introduction()">Танилцуулга</a>
                <a class="btn" id="btnGoal" @click="goal()">Зорилго</a>
                <a class="btn" id="btnVision" @click="vision()">Aлсын хараа</a>
              </div>
            </div>
            <!--/.title-->
            <div class="about_txt">
              <p>{{ Paragraph1 }}</p>
              <p>{{ Paragraph2 }}</p>
              <p>{{ Paragraph3 }}</p>
            </div>
          </div>
          <!--/.about_left_txt-->
        </div>
        <div class="col-md-8">
          <div class="about_right_img">
            <img src="../assets/img/teamAbout.jpg" width="650" height="470" alt />
          </div>
          <!--/.about_right_img-->
        </div>
      </div>
    </div>
    <!--/.container-->
  </section>
</template>

<script>
export default {
  data() {
    return {
      Paragraph1:
        "Манай байгууллага нь 2004 онд байгуулагдан сансрын холбооны чиглэлээр зөвлөх үйлчилгээ үзүүлж байгаад 2012 онд анх DVB-S2 технологийг Монголд анхлан нэвтрүүлж байсан туршлагатай.",
      Paragraph2:
        "Харин олон улсын сансрын холбооны Интерспутник байгууллагаас зарласан олон улсын тендерт манай байгууллагын төсөл шалгарч дараа үеийн DVB-S2X технологи бүхий Израель улсын Гилат компанийн сүүлийн үеийн SkyEdgeII-c X-architecture газрын станцыг 2020 оны 1-р сард амжилттай суурилуулж ажилд оруулаад байна.",
      Paragraph3:
        "Тус газрын станцаар 2,5 Гигабит/сек хүртэл урсгал гаргах хүчин чадалтай бөгөөд онгоц, галт тэрэг, автомашин зэрэг хөдөлгөөнт холбоонд ашиглах боломжтойгоос гадна үүрэн холбооны 4G, 5G үйлчилгээг дамжуулах боломжтой болж байгаа юм."
    };
  },
  methods: {
    introduction: function() {
      return (
        (this.Paragraph1 =
          "Манай байгууллага нь 2004 онд байгуулагдан сансрын холбооны чиглэлээр зөвлөх үйлчилгээ үзүүлж байгаад 2012 онд анх DVB-S2 технологийг Монголд анхлан нэвтрүүлж байсан туршлагатай."),
        (this.Paragraph2 =
          "Харин олон улсын сансрын холбооны Интерспутник байгууллагаас зарласан олон улсын тендерт манай байгууллагын төсөл шалгарч дараа үеийн DVB-S2X технологи бүхий Израель улсын Гилат компанийн сүүлийн үеийн SkyEdgeII-c X-architecture газрын станцыг 2020 оны 1-р сард амжилттай суурилуулж ажилд оруулаад байна."),
        (this.Paragraph3 =
          "Тус газрын станцаар 2,5Гигабит/сек хүртэл урсгал гаргах хүчин чадалтай бөгөөд онгоц, галт тэрэг, автомашин зэрэг хөдөлгөөнт холбоонд ашиглах боломжтойгоос гадна үүрэн холбооны 4G, 5G үйлчилгээг дамжуулах боломжтой болж байгаа юм.")
      );
    },
    goal: function() {
      (this.Paragraph1 =
        "Сансрын холбооны дэвшилтэт технологийг анхлан нэвтрүүлэгч байж хэрэглэгчийн сэтгэл ханамжаар өөрийн хөгжлийг тодорхойлно."),
        (this.Paragraph2 = ""),
        (this.Paragraph3 = "");
    },
    vision: function() {
      return (
        (this.Paragraph1 =
          "Мэдээлэл харилцаа холбооны үйлчилгээний хот хөдөө дэх тоон ялгарлыг багасгахад нийгмийн хариуцлагыг хэрэгжүүлэн иргэд, бизнесийн нэгжид мэдээлэл холбооны хамгийн шинэлэг, цогц үйлчилгээг үзүүлэгч компани байна."),
        (this.Paragraph2 = ""),
        (this.Paragraph3 = "")
      );
    }
  }
};
</script>



